import React from 'react'

const SettingsContext = React.createContext()

export function SettingsProvider({ settings, children }) {
    return <SettingsContext.Provider value={settings || {}}>{children}</SettingsContext.Provider>
}

export function useSettings() {
    const context = React.useContext(SettingsContext)

    if (context === undefined) {
        throw new Error('useSettings must be used with SettingsProvider')
    }

    return context
}
